<template lang="pug">
    
div( 
    :class="$style.root"
)
    MerchantLogo(
        v-if="isCanShowLogo"
        :class="$style.merchant"
    )
    Amount(
        v-if="state.merchant.amount"
        
        :amount="state.merchant.amount"
        :products="state.merchant.list"
    )
    Timer(
        v-if="!isOnlyQrLayout && state.timestamp && state.kind !== 'resolved'"
        :class="$style.timer"
    )
</template>

<script lang="ts">
import Vue from 'vue'

import { Timer } from '@/widgets/Timer'

import { useAppStore } from '@/shared/model'
import { useIsOnlyQrLayout } from '@/shared/lib/hooks/useIsOnlyQrLayout'

import MerchantLogo from './MerchantLogo.vue'
import Amount from './Amount.vue'

export default Vue.extend({
    name: 'Dynamic',
    props: {
        isCanShowLogo: {
            type: Boolean,
        },
    },
    setup() {
        const { state } = useAppStore()
        const { isOnlyQrLayout } = useIsOnlyQrLayout()

        return {
            state,
            isOnlyQrLayout,
        }
    },
    components: {
        MerchantLogo,
        Amount,
        Timer,
    },
})
</script>

<style module lang="scss">
.merchant {
    height: rem(28);
    box-sizing: border-box;
    margin-bottom: rem(20);
}

.amount {
    display: flex;
    flex-direction: column;
    gap: rem(4);
}

.timer {
    @include marginLevel(top, gray);
}
</style>
